import { apiV7nocache } from "../axiousWithCache"

const state = {
  reports: [],
  detailedReports: [],
  reportReadyEventPayload: null,
  detailedReportReadyEventPayload: null
}

const getters = {
  reports(state) {
    return state.reports
  },

  detailedReports(state) {
    return state.detailedReports
  },
  reportReadyEventPayload(state) {
    return state.reportReadyEventPayload
  },
  detailedReportReadyEventPayload(state) {
    return state.detailedReportReadyEventPayload
  }
}

const mutations = {
  SET_REPORTS(state, reports) {
    state.reports = reports
  },
  SET_DETAILED_REPORTS(state, detailedReports) {
    state.detailedReports = detailedReports
  },
  PUSH_REPORTS(state, reportsCollection = []) {
    if (state.reports && state.reports.length) {
      state.reports = state.reports.concat(reportsCollection)
    } else {
      state.reports = reportsCollection
    }
  },
  PUSH_DETAILED_REPORTS(state, detailedReportsCollection = []) {
    if (state.detailedReports && state.detailedReports.length) {
      state.detailedReports = state.detailedReports.concat(
        detailedReportsCollection
      )
    } else {
      state.detailedReports = detailedReportsCollection
    }
  },
  SET_REPORT_READY_EVENT_PAYLOAD(state, reportReadyEventPayload) {
    state.reportReadyEventPayload = reportReadyEventPayload
  },
  SET_DETAILED_REPORT_READY_EVENT_PAYLOAD(
    state,
    detailedReportReadyEventPayload
  ) {
    state.detailedReportReadyEventPayload = detailedReportReadyEventPayload
  }
}

const actions = {
  getReports(context, params) {
    return new Promise((resolve, reject) => {
      apiV7nocache
        .get("/admin/tardy/attendance/reports", { params })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getReportsCSV(context, params) {
    return new Promise((resolve, reject) => {
      apiV7nocache
        .get("/admin/tardy/attendance/reports/csv", { params: params })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getDetailedReports(context, params) {
    return new Promise((resolve, reject) => {
      apiV7nocache
        .get("/admin/tardy/attendance/reports/detailed", { params })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getDetailedReportsCSV(context, params) {
    return new Promise((resolve, reject) => {
      apiV7nocache
        .get("/admin/tardy/attendance/reports/detailed/csv", { params: params })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  tardyReportCsvDownload(_context, filename) {
    return new Promise((resolve, reject) => {
      apiV7nocache
        .get(`/admin/tardy/attendance/reports/csv/download/${filename}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  deleteCsvFile(_context, filename) {
    return new Promise((resolve, reject) => {
      apiV7nocache
        .delete(`/admin/tardy/attendance/reports/csv/delete/${filename}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchReportData(_context, { reportKey, perPage, page }) {
    return new Promise((resolve, reject) => {
      apiV7nocache
        .get("/admin/tardy/attendance/reports/fetch", {
          params: {
            report_key: reportKey,
            per_page: perPage,
            page: page
          }
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  deleteReportData(_context, { reportKey }) {
    return new Promise((resolve, reject) => {
      apiV7nocache
        .delete("/admin/tardy/attendance/reports/delete", {
          params: {
            report_key: reportKey
          }
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
